export enum TransactionStatus {
  Pending = 'PENDING',
  Signed = 'SIGNED',
  Rejected = 'REJECTED',
  Completed = 'COMPLETED',
  None = ''
}
